<template>
  <div>
    <div id="section-to-print">
    
      <div style="text-align: center; padding: 20px;">
        <div style="display:flex; justify-content: center; margin-right: 220px">
          <img style="width: 200px; margin-right: 20px" src="https://agribee.co/images/upload/Bee.logo-transparent.png" alt="logo">
          <div style="font-size: 22px; font-weight: bold; font-family: sans-serif, Arial, Helvetica, 'Hanuman-Regular'">
            <div>អាហ្គ្រីប៊ី( ខេមបូឌា ) ម.ក</div>
            <div>AGRIBEE( Cambodia ) Plc</div>
            <div style="font-size: 18px;">បង្កាន់ដៃទូទាត់ប្រាក់</div>
            <div style="font-size: 18px">{{ type }} Payment Receipt</div>
          </div>
        </div>

          <div style="text-align: right">Receipt No.{{ datas.receipt_no }}</div>

          <table style="width: 100%">
              <tr>
                <td style="width: 40px;">Pay To: </td>
                <td style="border-bottom: 1px solid black;">{{ datas.pay_to }}</td>
              </tr>

              <tr>
                <td style="width: 40px;">Amount: </td>
                <td style="border-bottom: 1px solid black;">{{ datas.amount | formatNumber }} {{ getCurrencySymbol(datas.currency_code) }}</td>
              </tr>

              <tr>
                <td style="width: 40px;">Amount ( Words ): </td>
                <td style="border-bottom: 1px solid black;">{{ datas.amount_in_word }}</td>
              </tr>

              <tr>
                <td style="width: 40px;">For: </td>
                <td style="border-bottom: 1px solid black;">{{ datas.note }}</td>
              </tr>
          </table>

          <table class="table-content">
            <tr>
              <th>Date</th>
              <th>{{ type }} #</th>
              <th>Description</th>
              <th>Amount Due</th>
              <th>Payment</th>
              <th>Balance</th>
            </tr>

            <tr v-if="datas.transaction">
              <td>{{ datas.transaction.date }}</td>
              <td>{{ datas.transaction.reference }}</td>
              <td>{{ datas.transaction.note }}</td>
              <td style="text-align: right">{{ datas.transaction.due_amount | formatNumber }} {{ getCurrencySymbol(datas.currency_code) }}</td>
              <td style="text-align: right">{{ datas.transaction.payment | formatNumber }} {{ getCurrencySymbol(datas.currency_code) }}</td>
              <td style="text-align: right">{{ datas.total_balance | formatNumber }} {{ getCurrencySymbol(datas.currency_code) }}</td>
            </tr>

            <tr>
              <td colspan="5" style="text-align: right"><b>Total</b></td>
              <td style="text-align: right">{{ datas.total_payment | formatNumber }} {{ getCurrencySymbol(datas.currency_code) }}</td>
            </tr>
          </table>

          <table style="with: 100%">
            <tr>
              <td>
                <!-- <div style="text-align: left; visibility: hidden">
                  <div>Payment Received</div>
                  <div>
                    <input type="checkbox"> Cash
                  </div>
                  <div>
                    <input type="checkbox"> Cheque, Bank
                  </div>
                  <div>Cheque, Bank Ref No: ...........</div>
                </div> -->
              </td>

              <td style="vertical-align: bottom; width: 300px; padding-top: 100px">
               <div style="border-top: 1px solid black; text-align: center; width: 300px">
                 Customer's Signature and Name
               </div>
              </td>
            </tr>
          </table>
      </div>
     
    </div>


  </div>

</template>

<style scoped>
  .table-content {
    width: 100%; margin: 20px 0; text-align: center; border-collapse: collapse;
  }
  .table-content,
  .table-content tr,
  .table-content tr td,
  .table-content tr th {
    border: 1px solid black;
    text-align: center;
    padding: 2px 5px;
  }
</style>

<script>

import {provider} from "@/service/provider";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin"
import moment from "moment";

export default {
  mixins: [MainMixin],
  data() {
    return {
      transaction_id: '',
      type: '',
      today:moment().format("YYYYMMDD"),
      datas: {},
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },

    handleRun() {
      if(this.transaction_id){
        let url = provider.baseURL + provider.getPaymentDetail;

  
        axios.post(url, {payment_id: this.transaction_id}, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {
            this.datas = res.data.data;
              this.$nextTick(() => { window.print(); });
              this.$nextTick(() => { this.$router.back(); });
          }
        }).catch(error => console.log(error));

      }else{
        this.$router.back();
      }
    }
  },
  mounted(){ this.handleRun() },
  created() { 
    this.transaction_id = this.$route.params.id; 
    this.type           = this.$route.params.type; 
  }
}
</script>